/* eslint-disable no-nested-ternary */

import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  ButtonDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from 'reactstrap';
import { PseudoStates, useFetch, Button } from '@cordata/buffet';
import fileDownload from 'js-file-download';
import { format } from 'date-fns';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import {
  authorizedRbInstance as Api,
} from '~/utils';

const BatchImportDetails = ({ id, handleCancel }) => {
  const [status, data] = useFetch(`admin/batch-imports/${id}`);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  /* eslint-disable-next-line */
  const handleFileDownload = ({ errored_only }) =>
    Api.get(`/admin/batch-imports/${id}/csv`, {
      responseType: 'blob',
      params: {
        errored_only,
      },
    }).then(res =>
      res.data.size > 0 &&
      fileDownload(res.data, `${data.attributes.dataType}-batch-import-${format(data.attributes.createdDate, 'MM/DD/YYYY HH:mm A')}.csv`));

  return (
    <Modal isOpen={!!id} backdrop="static">
      <ModalHeader>{id}</ModalHeader>

      <ModalBody>
        {id}
        {status === 'success'
          ? data.attributes.dataType
          : (
            <PseudoStates status={status} />
          )
        }
      </ModalBody>

      <ModalFooter className="d-flex">
        <div className="mr-auto">
          <ButtonDropdown
            isOpen={isDropdownOpen}
            toggle={() => setIsDropdownOpen(!isDropdownOpen)}
          >
            <Button
              type="button"
              outline
              onClick={() => handleFileDownload({ errored_only: true })}
              icon="download"
            >
              Download Errored
            </Button>

            <DropdownToggle outline caret />

            <DropdownMenu>
              <DropdownItem onClick={() => handleFileDownload({ errored_only: false })}>
                <FontAwesomeIcon icon="file-import" />
                <span className="d-none d-md-inline ml-2">Download All</span>
              </DropdownItem>
            </DropdownMenu>
          </ButtonDropdown>
        </div>

        <div className="ml-auto">
          <Button
            outline
            type="cancel"
            onClick={handleCancel}
          >
            Cancel
          </Button>
        </div>
      </ModalFooter>
    </Modal>
  );
};

BatchImportDetails.propTypes = {
  id: PropTypes.string.isRequired,
  handleCancel: PropTypes.func.isRequired,
};

export default BatchImportDetails;
